import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  useColorModeValue,
} from '@chakra-ui/react';
import { SidebarContent } from './components/Content';

export interface RouteItem {
  name: string;
  path: string;
  icon: React.ReactElement;
  showInNav?: boolean;
  roles?: string[];
  testId?: string;
}

interface SidebarProps {
  routes: RouteItem[];
  isOpen: boolean;
  onClose: () => void;
}

export default function Sidebar({ routes, isOpen, onClose }: SidebarProps) {
  const sidebarBg = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.08)',
    'unset',
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <Box
        display={{ base: 'none', xl: 'block' }}
        position="fixed"
        minH="100%"
      >
        <Box
          bg={sidebarBg}
          w="285px"
          h="calc(100vh - 32px)"
          m="16px 0 16px 16px"
          borderRadius="30px"
          overflowX="hidden"
          overflowY="auto"
          boxShadow={shadow}
        >
          <SidebarContent routes={routes} />
        </Box>
      </Box>

      {/* Mobile Drawer */}
      <Drawer isOpen={isOpen} onClose={onClose} placement="left">
        <DrawerOverlay />
        <DrawerContent
          w="285px"
          maxW="285px"
          my="16px"
          ms="16px"
          borderRadius="16px"
          bg={sidebarBg}
        >
          <DrawerCloseButton
            zIndex="3"
            _focus={{ boxShadow: 'none' }}
            _hover={{ boxShadow: 'none' }}
          />
          <DrawerBody px="0" pb="0" overflowY="auto">
            <SidebarContent routes={routes} onClose={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
